import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'nameFilter'
})
export class NameFilterPipe implements PipeTransform {
  transform(val: any): string {
    if (!val)
      return '-';

    if (val.name)
      return val.name;

    if (val.id)
      return val.id;

    if (val.thingId)
      return val.thingId;

    if (val.areaId)
      return val.areaId;

    return '-';
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/pipes/nameFilter.pipe.ts